import { css } from 'emotion'
import { Colors, SliderTitle, SliderContent, SliderSubtitle, SliderLabel, SliderDescription } from './../'
import { Easings } from '../core';

// SLIDER
export const SliderStyle = css({
  position: 'relative',
  '.template-content': {
    padding: '1.5rem',
    paddingBottom: 'calc(1.5rem)',
    // '@media (min-width: 1224px) ': {
    //   padding: '4rem',
    //   paddingBottom: '6rem',
    // },
    '@media (min-height: 660px) and (min-width: 1224px)': {
      padding: '8rem',
      paddingBottom: '6rem',
    },
    
    'p, ul, ol': {
      ...SliderContent,
    }
  },
  '.title': {
    ...SliderTitle,
    margin: 0,
  },
  '.subtitle': {
    ...SliderSubtitle,
    margin: 0,
    marginBottom: '2rem',
    textTransform: 'uppercase',
    '@media (min-width: 1024px)': {
      marginBottom: '4rem',
    },
    '&--brand':{
      fontSize: '1.875rem',
      '@media (min-width: 1024px)': {
        fontSize: '3rem',
      },
      '&:after': {
        content: "''",
        width: 50,
        height: 4,
        background: 'black',
        display: 'block',
        marginTop: '2.5rem'
      }
    },
    '&-h3': {
      textTransform: 'uppercase',
      fotnSize: '1.125rem',
      margin: '0.625rem 0',
    }
  },
  '.title-brand': {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  '.product-template': {
    position: 'relative',
    // overflow: 'visible',
    '&--video': {
      height: '100%',
    }
  },
  '.template-scroll': {
    display: 'flex',
    flexWrap: 'wrap',
    '@media (min-width: 1024px)': {
      display: 'inherit',
    }
  }
})

const fixedCol = (picture, color) => ({
  position: 'relative',
  height: 360,
  background: `url(${picture}) no-repeat center`,
  backgroundSize: color ? 'contain' : 'cover',
  backgroundColor: color,
  '@media (min-width: 1024px)': {
    position: 'fixed',
    top: 80,
    height: 'calc(100% - 160px)',
  }
})

// SLIDES POSITION
export const SlideStyle = (isVisibled) => css({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  opacity: isVisibled ? 1 : 0,
  display: isVisibled ? 'block' : 'none',
})

// INTRO STYLE - Intro range
export const IntroTemplateStyle = (picture, color) =>css({
  '.template-right': {
    ...fixedCol(picture, color),
    right: 0,
    width: '100%',
    order: -1,
  },
  '.template-left': {
    order: 1,
    width: '100%',
    background: 'white',
    '@media (min-width: 1024px)': {
      maxWidth: '50%',
      flexBasis: '50%',
      width: 'auto',
    }
  },
  '.template-inner': {
    width: '50%',
  },
  '.content-row': {
    margin: '1rem 0px',
    '.label': {
      ...SliderLabel,
      color: Colors.mediumGrey,
      maxWidth: '100px',
      flexBasis: '100px',
      paddingRight: 5,
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/4 * 100%)',
        flexBasis: 'calc(1/4 * 100%)',
        padding: 0,
      }
    },
    '.description': {
      maxWidth: 'calc(100% - 100px)',
      flexBasis: 'calc(100% - 100px)',
      ...SliderDescription,
      margin: 0,
      color: 'black',
      fontWeight: 'bold',
      paddingLeft: '0.625rem',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(3/4 * 100%)',
        flexBasis: 'calc(3/4 * 100%)',
      },
      '.flex': {
        margin: '1rem 0px',
        alignItems: 'center',
        '&:first-child': {
          marginTop: 0,
        }
      }
    },
    '.range-label': {
      maxWidth: '100px',
      flexBasis: '100px',
      paddingRight: '1rem',
      fontWeight: 'bold',
    },
    '.range': {
      maxWidth: 360,
      width: 'calc(100% - 100px)',
      flexBasis: 'calc(100% - 100px)',
    }
  }
}, {
  '.template-right': {
    '@media (min-width: 1024px)': {
      width: '50%',
    }
  }
})

// BASE STYLE - Landscape - col 1/2 
export const BaseTemplateStyle = (picture, type, color) => css({
  height: '100%',
  '.template-left': {
    ...fixedCol(picture, color),    
    left: 0,
    width: '100%',
    '@media (min-width: 1024px)': {
      position: 'fixed',
      height: 'calc(100% - 160px)',
    }
  },
  '.template-right': {
    maxWidth: '100%',
    flexBasis: '100%',
    
    '@media (min-width: 1024px)': {
      paddingLeft: '3rem',
      paddingRight: '3rem',
      maxWidth: type === 'imagelandscape' ? 'calc(1/3 * 100%)' : 'calc(1/2 * 100%)',
      flexBasis: type === 'imagelandscape' ? 'calc(1/3 * 100%)' : 'calc(1/2 * 100%)',
      marginLeft: type === 'imagelandscape' ? 'calc(2/3 * 100%)' : 'calc(1/2 * 100%)', 
    },
    '@media (min-width: 1440px)': {
      paddingLeft: '6rem',
      paddingRight: '6rem',
    },

    '@media (min-width: 1660px)': {
      paddingLeft: '8rem',
      paddingRight: '8rem',
    },
  },
  '.subtitle': {
    marginTop: '5rem',
    '&:first-of-type':{
      marginTop: 0,
    },
  },
  '.content': {
    'h3': {
      // ...SliderSubtitle,
    }
  },
  '.flickity': {
    '&-slider': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    '&-button': {
      display: 'none',
    },
    '&-page-dots': {
      display: 'flex',
      listStyle: 'none',
      position: 'absolute',
      bottom: '2rem',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 5,
      padding: 0,
      '& > li': {
        width: 10,
        height: 10,
        borderRadius: 9999,
        background: 'white',
        border: '1px solid black',
        opacity: 0.5,
        margin: '0rem 5px',
        '&:before': {
          display:'none',
        },
        '&.is-selected': {
          opacity: 1,
        }
      }
    }
  },
}, {
  '.template-left': {
    '@media (min-width: 1024px)': {
      width: type === 'imagelandscape' ? 'calc(2/3 * 100%)' : 'calc(1/2 * 100%)',
    }
  }
})

// BASE STYLE - Landscape - col 1/2 
export const TextTemplateStyle = css({
  '.template-right': { 
    maxWidth: '100%',
    flexBasis: '100%',
    '@media (min-width: 1024px)': {
      maxWidth: 'calc(1/2 * 100%)',
      flexBasis: 'calc(1/2 * 100%)',
      paddingLeft: '4rem',
    }
  },
  '.template-left': {
    maxWidth: '100%',
    flexBasis: '100%',
    '@media (min-width: 1024px)': {
      maxWidth: 'calc(1/2 * 100%)',
      flexBasis: 'calc(1/2 * 100%)',
      paddingRight: '4rem',
    }
  }
})


// SLIDER 
export const SliderTemplateStyle = (picture, ready, color) => css({
  'h2': {
    'maxWidth': '100%',
    'flexBasis': '100%',
  },
  'ul': {
    'li': {
      ...SliderContent,
      margin: '2rem 0px',
      alignsItems: 'flex-start',
      opacity: 0.25,
      cursor: 'pointer',
      transition: 'all 400ms ease',
      '&.active': {
        opacity: 1,
      }
    },
    '.number': {
      position: 'relative',
      paddingRight: '50px',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: -8,
        left: 32,
        height: 40,
        width: 4,
        background: 'black',
      }
    },
    '.label': {
      maxWidth: 'calc(100% - 80px)',
      flexBasis: 'calc(100% - 80px)',
    }
  },
  '.template-right': {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '50%',
      marginLeft: '50%',
    }
  },
  '.template-left': {
    width: '100%',
    height: 360,
    background: `url(${picture}) no-repeat center`,
    backgroundSize: color ? 'contain' : 'cover',
    backgroundColor: color,
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'white',
      zIndex: 10,
      transition: `transform 400ms ${Easings.customEase}`,
      transform: `scaleX(${ready ? 0 : 1})`,
      transformOrigin: 'center right',
    },
    '@media (min-width: 1024px)': {
      position: 'fixed',
      top: 80,
      height: 'calc(100% - 160px)',
      width: '50%',
    },
  },
}, !color && {
  '.template-left': {
    '&--top': {
      backgroundPosition: 'center top',
    },
    '&--center': {
      backgroundPosition: 'center center',
    },
    '&--bottom': {
      backgroundPosition: 'center bottom',
    }
  }
})

// SUGGESTION STYLE
export const SuggestTemplateStyle = (picture, color) => css({
  height: '100%',
  '.template-right' : {
    width: '100%',
    paddingTop: '4rem',
    '&:not(.full)': {
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
      '@media (min-width: 1024px)': {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
      '@media (min-width: 1440px)': {
        paddingLeft: '6rem',
        paddingRight: '6rem',
      },

      '@media (min-width: 1660px)': {
        paddingLeft: '8rem',
        paddingRight: '8rem',
      }
    },
    '& > .flex' : {
      alignItems: 'flex-start',
    },
    '.slideshow-article-nav': {
      'button > svg': {
       fill: 'black',
      }
    },
    '@media (min-width: 1024px)': {
      width: 'calc(1/2 * 100%)',
      marginLeft: 'calc(1/2 * 100%)',
    },
    'h2.subtitle, .suggest-container' : {
      maxWidth: '100%',
      flexBasis: '100%',
    },
    '.suggest-container': {
      marginLeft: '-1rem',
      marginRight: '-1rem',
    },
    '&.full': {
      maxWidth: '100%',
      flexBasis: '100%',
      width: '100%',
      marginLeft: 0,
      'h2.subtitle' : {
        maxWidth: '100%',
        flexBasis: '100%',
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(1/4 * 100%)',
          flexBasis: 'calc(1/4 * 100%)',
        },
      },
      '.suggest-container': {
        maxWidth: '100%',
        flexBasis: '100%',
        overflow: 'visible',
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(3/4 * 100%)',
          flexBasis: 'calc(3/4 * 100%)',
        },
      },
    },
    '.card': {
      maxWidth: `50%`,
      flexBasis: `50%`,
      padding: '0.5rem',
      minWidth: 0,
      '@media (min-width: 1024px)': {
        maxWidth: `calc(1/${picture ? 2 : 3} * 100%)`,
        flexBasis: `calc(1/${picture ? 2 : 3} * 100%)`,
        padding: '1rem',
        minWidth: 260,
      },
      '@media (min-width: 1640px)': {
        minWidth: 280,
      },
      '&-info': {
        minHeight: 110,
      }
    },
    '.card-inner': {
      boxShadow: `0 0 10px 0 ${Colors.shadow}`,
      '@media (min-width: 1024px)':{
        boxShadow: `0 0 20px 0 ${Colors.shadow}`,
      },
      'h2': {
        minHeight: 0,
      }
    }
  },
  '.template-scroll': {
    '@media (min-width: 1024px)': {
      height: '100%',
    }
  },
  '.template-left': {
    ...fixedCol(picture, color),
    left: 0,
    width: '100%',
  },
}, {
  '.template-left': {
    height: 360,
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '50%',
      position: 'fixed',
      top: 80,
      height: 'calc(100% - 160px)',
    }
  }
}, picture && {
  'h2.subtitle':{
    marginBottom: '2rem'
  }
})

// Social STYLE
export const SocialTemplateStyle = (picture) => css({
  '.template-left': {
    background: `url(${picture}) no-repeat center`,
    backgroundSize: 'contain',
    width: '100%',
    height: 360,
    '@media (min-width: 1024px)': {
      width: '50%',
      position: 'fixed',
      top: 80,
      height: 'calc(100% - 160px)',
    }
  },
  '.template-right': {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '50%',
      marginLeft: '50%',
    }
  },
  '.social-label': {
    marginLeft: '1rem',
    marginRight: '0.5rem',
    fontWeight: 'bold',
  },
  '.social-row': {
    margin: '1rem 0px',

    'a': {
      maxWidth: 'calc(100% - 140px)',
      flexBasis: 'calc(100% - 140px)',
      wordBreak: 'break-word',
    },
  },
  '.social-svg, .social-label': {
    display: 'inherit',
  },
  'a': {
    color: 'black',
  }
})

// FLICKITY
export const flickitySlideStyle = (picture, color) => css({
  height: '100%',
  width: '100%',
  background: `url(${picture}) no-repeat center `,
  backgroundSize: color ? 'contain': 'cover',
  backgroundColor: color,
  opacity: 0,
  zIndex: 0,
  // transition: 'opacity 100ms ease !important',
  '&.is-selected, &[aria-selected="true"]': {
    opacity: 1,
    zIndex: 2,
  },
})


// WEBPACK FOOTER //
// ./src/styles/components/slider.js